import type { CSSProperties, ReactNode } from 'react';
import { useTenant } from '../../tenant/TenantContext';
import { JobsBar } from './JobsBar';
import heroUrl from './assets/header-jobs-library.webp';
import './scene.css';
import './dashboard.css';

/** How many quiet cards stand in for the jobs while they are read. */
const GHOSTS = 3;

/**
 * The jobs home while its jobs are read (review 2026-10-06: a slow connection left a blank page
 * with nothing on it). The bar and the drawing are already the home's own, so the person can leave
 * for Settings or sign out; the cards are quiet shapes of the ones to come. The router shows this
 * only when the read takes longer than a beat, so a normal load never flickers through it.
 */
export function JobsPending(): ReactNode {
  const tenant = useTenant();
  return (
    <div className="paige-jobs paige-scene" aria-busy="true">
      <JobsBar tenantId={tenant.id} />
      <div
        className="paige-hero"
        style={{ '--hero': `url(${heroUrl})` } as CSSProperties}
        aria-hidden="true"
      />
      <div className="paige-jobs__panel">
        <p className="paige-jobs__line" role="status">
          Opening your jobs…
        </p>
        <div className="paige-jobs__grid" aria-hidden="true">
          {Array.from({ length: GHOSTS }, (_, i) => (
            <div key={i} className="job-row job-row--ghost">
              <span className="job-row__spine" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
